module.exports = __webpack_public_path__ + "static/media/unoriginal-inflator-badge.ecdcb08a.svg";